export enum ClaimObjectTypeCodeEnum {
    Conflict = 'Conflict',
    Cost = 'Cost',
    Injury = 'Injury',
    Hide = 'Hide',
    Damage = 'Damage',
    DamageOrInjury = 'Damage or injury',
}
